'use strict';

module.exports = require(process.env.REACT_APP_TARGET === 'server' ? './server' : './shim');